import { createEnvironmentFlags, getFlag } from '@zola-helpers/client/dist/es/featureFlags';
import getEnvironment from '@zola-helpers/client/dist/es/util/environment'; // this could be removed, if you fix up all the places that import getEnvironment

export const FLAGS = {
  // Permanent Flags
  paypalSandbox: createEnvironmentFlags(true, true, false), // Do not remove.
  showHolidayCollectionLinks: createEnvironmentFlags(false, false, false), // REGISTRY-4769
  showHolidayCollectionIcon: createEnvironmentFlags(false, false, false), // REGISTRY-4770

  // Temporary Feature Flags
  gmPhase1: createEnvironmentFlags(true, true, false), // CE-2
  enhancedPromoMessaging: createEnvironmentFlags(true, true, false), // Enhanced promo messagiing on cart items
  featureToggle: createEnvironmentFlags(true, true, false),
  invitesPlaceCards: createEnvironmentFlags(true, true, true), // COMMERCE-563
  bookingStatusReminder: createEnvironmentFlags(true, true, true), // INSPO-4550
  paypalSDKMigration: createEnvironmentFlags(true, true, true), // COMMERCE-1025
  hideUniversalSearchBar: createEnvironmentFlags(true, true, true), // INSPO-6112
  hideUniversalSearchBarInDetailPages: createEnvironmentFlags(true, true, false), // INSPO-6520
};

const get = (flag) => getFlag(FLAGS, flag);

export default {
  get,
  getEnvironment,
};
